<script lang="ts">
	// Services
	import { format } from 'src/services/i18n';

	// Design system components
	import { ButtonV2, Stack, Text } from '@Shelly/shelly-design-system';
	import { push } from 'svelte-spa-router';
</script>

<Stack
	direction="column"
	directionMobile="row"
	align="between"
	alignMobile="none"
	gap="m"
	class="align-items-center"
>
	<div>
		<Text styleType="body-medium" class="mb-s">
			{$format('tab_changelog', { default: 'Changelog' })}
		</Text>
		<Text styleType="body-small" class="text-color-muted">
			{$format('description_user_settings_changelog', {
				default: "Check out our changelog to stay up to date with what's new and improved.",
			})}
		</Text>
	</div>

	<ButtonV2 size="m" variant="secondary" on:click={() => push(`/changelog`)}>
		{$format('button_open', {
			default: 'Open',
		})}
	</ButtonV2>
</Stack>
